import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TicketFormData } from "./CreateTicketPage";
import InputField from "../../../components/form/InputField";
import TextAreaField from "../../../components/form/TextAreaField";

interface Props {
  register: UseFormRegister<TicketFormData>;
  errors: FieldErrors<TicketFormData>;
}

const TicketForm: React.FC<Props> = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
   <>
    <InputField
      placeholder=""
      label={t("subject")}
      register={register("title", { required: t("required_field") })}
      error={errors.title}
    />
    <TextAreaField
      placeholder=""
      label={t("description")}
      register={register("description", { required: t("required_field") })}
      error={errors.description}
    />
   </>
  );
};

export default TicketForm;
